import { IMessageTemplateItem } from "us.collection.case/interfaces";

/**
 * Add new name for state
 * @param templates - Template list
 * @param displayName - New display name
 * @param templateId - Display changed template id
 * @returns
 */
export const addNewDisplayNameForTemplates = (
  templates: Array<any>,
  displayName: string,
  templateId: number
): Array<any> => {
  try {
    if (Array.isArray(templates)) {
      return templates?.map((template: IMessageTemplateItem) => {
        if (template.id === templateId) {
          return {
            ...template,
            displayName,
          };
        }
        return template;
      });
    } else {
      return [];
    }
  } catch (error) {
    return templates;
  }
};
